import {tiNormalizer, labels} from '../../util/utils';

const mapDocuments = ({
	documentId,
	documentName,
	documentType: documentTypeId,
	engagementId,
	fileExtension: fileExt,

	isConflicted = false,
	isShared = false,

	documentSourceID,
	hasComments,
	hasHiddenSheets,
	hasTrackChanges,
	hash,
	isFinalVersion,
	isHighlighted,
	versionNumber,
	externalStreamId = null
}) => ({
	documentId,
	documentName,
	documentTypeId,
	engagementId,
	id: documentId,
	fileExt,
	isConflicted,
	isShared,
	documentSourceID,
	hasComments,
	hasHiddenSheets,
	hasTrackChanges,
	hashValue: hash,
	isFinalVersion,
	isHighlighted,
	versionNumber,
	externalStreamId: externalStreamId !== null ? externalStreamId : documentId
});

const mapTeams = ({componentID}) => componentID;

const mapInstructions = ({
	gaInstructionGuid: id,
	gaInstructionName: instructionName,
	gaInstructionDescription: description,
	associatedDocuments: documents,
	associatedComponents: teams = [],
	...rest
}) => ({
	...rest,
	id,
	instructionName,
	title: instructionName,
	description,
	documents: documents.map(mapDocuments),
	documentCount: documents.length,
	teams: teams !== null ? teams.map(mapTeams) : []
});

const mapSections = ({
	instructionSectionId: id,
	instructionSectionName: label,
	knowledgeInstructionSectionId,
	instructions,
	hashValue = null,
	...rest
}) => {
	const mappedInstructions = instructions.map(mapInstructions);
	return {
		...rest,
		id,
		label,
		knowledgeInstructionSectionId,
		hashValue,
		count: instructions.length,
		instructions: [
			...tiNormalizer.filterSortKnowledge(mappedInstructions),
			...tiNormalizer.filterSortCustom(mappedInstructions)
		]
	};
};

export default ({instructionJson, hashValue}) => {
	const {instructionSentDate: sentDate, instructionSections} = instructionJson;
	const mappedSections = instructionSections.map(mapSections);
	return {
		hashValue,
		sentDate,
		sections: [
			...tiNormalizer.filterSortKnowledge(mappedSections, 'knowledgeInstructionSectionId', 'noRF'),
			...tiNormalizer.filterSortCustom(mappedSections, 'label'),
			...tiNormalizer
				.filterSortKnowledge(mappedSections, 'knowledgeInstructionSectionId', 'RF')
				.map(({label, ...rest}) => ({...rest, label: labels.groupTask}))
		]
	};
};
